export default __webpack_public_path__ + "static/media/mobile.0bb38763.png";